import styled from 'styled-components';
import { variants } from '../map';
export const Text = styled.span.withConfig({
  displayName: "Text",
  componentId: "sc-s3ssy9-0"
})(["", " ", " ", " ", ""], ({
  $color
}) => $color && `color: ${$color};`, ({
  $variant = 'standard'
}) => variants[$variant], ({
  $uppercase
}) => $uppercase && 'text-transform: uppercase;', ({
  $ellipsis
}) => $ellipsis && 'text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: inline-block; max-width: 100%;');